import React from 'react';
import { connect } from 'react-redux';
import {
  ChiTietDon,
  QuaTrinhXuLy,
  GiaiQuyetDonCanBo,
  NhapThongTinToTTXX,
  CanBoKiemTraDeXuat,
  LapDuThaoCanBo,
  KetQuaXuLyDon,
  LapDuThaoDonKhieuNaiCanBo,
  CanBoGiaiQuyetYeuCauLapDuThao,
  CanBoNhanYeuCauTheoDoiThucHien
} from './subView';
import { Toastr } from 'modules/toastr';
import { msg } from 'constants/message';
import { Link, browserHistory } from 'react-router';
import { GiaiQuyetDonThu, LetterProcessingWorkFlow, Letter, Reception} from 'api';
import {ConfirmDialog} from 'modules/dialog';
import { CheckViewPermission } from 'modules/login/CheckPermission';

class TuGiaiQuyetDon extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      id: this.props.params.id,
      isOpen: true,
      isSubmit: false,
      hideKetQuaXuLyDon: false,
      nameComponent: '',
      typeComponent: '',
      data: {},
      dataLichSuQuaTrinhXuLy: [],
      dataGiaiQuyetDon: [],
      coQuanQuanLyNguoiDung: [],
      dataNextStates: '',
      canBoXuLyChiDinh: '',
      yKienGiaiQuyet: '',
      donViThamTraXacMinh: '',
      ngayHetHanTTXM: '',
      ngayHetHanGiaiQuyet: '',
      dataLichSuGiaiQuyet: [],
      loaiDon: '',
      dataKetQuaXuLyDon: {},
      donViGiaoTTXM: {},
      taiLieuDinhChi: {},
      listTaiLieuVanThuKiemTraDeXuat: [],
      dataKiemTraDeXuat: [],
      backConfirm: false,
      hasChange: false
    }
  }

  componentDidMount() {
    this.getDonDetail();
    this.getQuyTrinhXuLyHistory()
  }

  getDonDetail() {
    let params = {
      id: this.state.id
    }

    Letter.actions.getDonDetail.request(params).then(res => {
      if (res.data) {
        let resData = res.data;
        if (CheckViewPermission(res.data)) {
          Reception.actions.getDonInfo.request({ id: this.state.id }).then(res1 => {
            if (res1.data) {
              resData = {...resData, ...res1.data};
            }

            this.setState({
              data: resData,
              loaiDon: resData.loaiDon,
              dataKetQuaXuLyDon: {
                thamQuyenGiaiQuyet: resData.thamQuyenGiaiQuyetInfo ? resData.thamQuyenGiaiQuyetInfo.ten : ''
              }
            });
            this.getLichSuGiaiQuyetDon(this.state.id);
          });
        } else {
          browserHistory.push('/page-403');
        }
      }
    });
  }

  getQuyTrinhXuLyHistory() {
    LetterProcessingWorkFlow.actions.getQuyTrinhXuLyHistory.request({ donId: this.state.id }).then(res => {
      this.setState({ dataLichSuQuaTrinhXuLy: res.data ? res.data._embedded.lichSuQuaTrinhXuLies : [] });
    });
  }

  handleChange(e) {
    this.setState({[e.target.name]: e.target.value});
  }

  getLichSuGiaiQuyetDon(id) {
    let params = {
      id: id
    }
    GiaiQuyetDonThu.actions.getLichSuGiaiQuyetDon.request(params).then(res => {
      this.state.dataKetQuaXuLyDon.yKienXuLy = res.data.thongTinGiaiQuyetDonInfo.yKienXuLyDon;
      this.state.dataKetQuaXuLyDon.phongBanGiaiQuyet = res.data.phongBanGiaiQuyetInfo.ten;
      this.setState({
        dataLichSuGiaiQuyet: res.data
      },() => {
        this.setState({
          nameComponent: res.data.nextFormInfo ? res.data.nextFormInfo.alias : '',
          typeComponent: res.data.nextStateInfo ? res.data.nextStateInfo.type : '',
          dataKetQuaXuLyDon: this.state.dataKetQuaXuLyDon,
          dataKiemTraDeXuat: res.data.thongTinYeuCauKiemTraDeXuatInfo
        });
      })
      this.checkHideKetQuaXuLyDon()
    });
  }

  renderWorkFollow() {
    switch (this.state.nameComponent) {
      case 'CanBoGiaiQuyetDonAction':
        return (
          <GiaiQuyetDonCanBo
          handleChangeData = {this.handleChangeData.bind(this)}
          handleBack = {this.handleBack.bind(this)}
          id={this.state.id}
          tuGiaiQuyet={true}
          dataGiaiQuyet = {this.state.dataLichSuGiaiQuyet}
          thongTinGiaiQuyetDonId={this.state.data.thongTinGiaiQuyetDonId}
          listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDon}
          listTaiLieuVanThuGiaiQuyetDonView={this.state.data.listTaiLieuVanThuGiaiQuyetDonView}
          listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM={this.state.data.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM}
          listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ={this.state.data.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ}
          listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra={this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra}
          listTaiLieuVanThuGiaiQuyetDonGiaHanGQ={this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ}
          dataNextStates={this.state.dataNextStates}
          coQuanQuanLyNguoiDung={this.state.coQuanQuanLyNguoiDung}
          updateGiaiQuyetDon={this.updateGiaiQuyetDon.bind(this)}
          saveGiaiQuyetDon={this.saveGiaiQuyetDon.bind(this)}
          loaiDon={this.state.loaiDon}
          donInfo={this.state.data}
          thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
          noiDungDonThu={this.state.data.noiDung}
          listNguoiDungDon={this.state.data.listNguoiDungDon}
          coQuanDangQuyetInfo={this.state.data.coQuanDangQuyetInfo}
          donViGiaoTTXM={this.state.donViGiaoTTXM}/>
        )
      case 'CanBoTTXMAction':
        return (
          <NhapThongTinToTTXX
          handleChangeData = {this.handleChangeData.bind(this)}
          handleBack = {this.handleBack.bind(this)}
          id={this.state.id}
          tuGiaiQuyet={true}
          donInfo={this.state.data}
          dataNextStates={this.state.dataNextStates}
          listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM}
          thongTinGiaiQuyetDonId={this.state.data.thongTinGiaiQuyetDonId}
          updateGiaiQuyetDon={this.updateGiaiQuyetDon.bind(this)}
          saveGiaiQuyetDon={this.saveGiaiQuyetDon.bind(this)}
          loaiDon={this.state.loaiDon}/>
        )

      case 'CanBoGiaiQuyetDonLapDuThaoAction':
        if (this.state.loaiDon == 'DON_KHIEU_NAI') {
          return (
            <LapDuThaoDonKhieuNaiCanBo
            handleChangeData = {this.handleChangeData.bind(this)}
            handleBack = {this.handleBack.bind(this)}
            id={this.state.id}
            dataNextStates={this.state.dataNextStates}
            listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM}
            tuGiaiQuyet={true}
            listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM={this.state.data.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM}
            listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ={this.state.data.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ}
            listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra={this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra}
            listTaiLieuVanThuGiaiQuyetDonGiaHanGQ={this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ}
            donInfo={this.state.data}
            thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
            isTTXMLai={this.state.data.laTTXMLai}
            updateGiaiQuyetDon={this.updateGiaiQuyetDon.bind(this)}
            thongTinGiaiQuyetDonId={this.state.data.thongTinGiaiQuyetDonId}
            saveGiaiQuyetDon={this.saveGiaiQuyetDon.bind(this)}
            loaiDon={this.state.loaiDon}/>
          )
        } else {
          return (
            <LapDuThaoCanBo
            handleChangeData = {this.handleChangeData.bind(this)}
            handleBack = {this.handleBack.bind(this)}
            id={this.state.id}
            dataNextStates={this.state.dataNextStates}
            listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM}
            tuGiaiQuyet={true}
            listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM={this.state.data.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM}
            listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ={this.state.data.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ}
            listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra={this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra}
            listTaiLieuVanThuGiaiQuyetDonGiaHanGQ={this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ}
            donInfo={this.state.data}
            thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
            isTTXMLai={this.state.data.laTTXMLai}
            updateGiaiQuyetDon={this.updateGiaiQuyetDon.bind(this)}
            thongTinGiaiQuyetDonId={this.state.data.thongTinGiaiQuyetDonId}
            saveGiaiQuyetDon={this.saveGiaiQuyetDon.bind(this)}
            loaiDon={this.state.loaiDon}/>
          )
        }

      case 'CanBoTDTHAction':
        return (
          <CanBoNhanYeuCauTheoDoiThucHien
          handleChangeData = {this.handleChangeData.bind(this)}
          thongTinGiaiQuyetDonId={this.state.data.thongTinGiaiQuyetDonId}
          handleBack = {this.handleBack.bind(this)}
          dataNextStates={this.state.dataNextStates}
          listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
          tuGiaiQuyet={true}
          donInfo={this.state.data}
          thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
          id={this.state.id}
          postGiaiQuyetDon={this.postGiaiQuyetDon.bind(this)}
          updateGiaiQuyetDon={this.updateGiaiQuyetDon.bind(this)}
          saveGiaiQuyetDon={this.saveGiaiQuyetDon.bind(this)}
          loaiDon={this.state.loaiDon}
          />
        )
      case 'canBoKiemTraDeXuat':
        return (
          <CanBoKiemTraDeXuat
          handleChangeData = {this.handleChangeData.bind(this)}
          handleBack = {this.handleBack.bind(this)}
          id={this.state.id}
          tuGiaiQuyet={true}
          thongTinGiaiQuyetDonId={this.state.data.thongTinGiaiQuyetDonId}
          listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuKiemTraDeXuat}
          dataNextStates={this.state.dataNextStates}
          donInfo={this.state.data}
          thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
          dataKiemTraDeXuat = {this.state.dataKiemTraDeXuat}
          coQuanQuanLyNguoiDung={this.state.coQuanQuanLyNguoiDung}
          postGiaiQuyetDon={this.postGiaiQuyetDon.bind(this)}
          saveGiaiQuyetDon={this.saveGiaiQuyetDon.bind(this)}
          loaiDon={this.state.loaiDon}
          />
        )
      case 'CanBoGiaiQuyetDonXuLySauKhiNhanDuThaoAction':
        return (
          <LapDuThaoDonKhieuNaiCanBo
          handleChangeData = {this.handleChangeData.bind(this)}
          handleBack = {this.handleBack.bind(this)}
          id={this.state.id}
          nhanDuThao={true}
          tuGiaiQuyet={true}
          dataNextStates={this.state.dataNextStates}
          listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM}
          donInfo={this.state.data}
          thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
          listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM={this.state.data.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM}
          listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ={this.state.data.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ}
          listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra={this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra}
          listTaiLieuVanThuGiaiQuyetDonGiaHanGQ={this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ}

          updateGiaiQuyetDon={this.updateGiaiQuyetDon.bind(this)}
          thongTinGiaiQuyetDonId={this.state.data.thongTinGiaiQuyetDonId}
          saveGiaiQuyetDon={this.saveGiaiQuyetDon.bind(this)}
          loaiDon={this.state.loaiDon}/>
        )
      case 'CanBoTTXMChuyenDuThaoAction':
        return (
          <CanBoGiaiQuyetYeuCauLapDuThao
          handleChangeData = {this.handleChangeData.bind(this)}
          handleBack = {this.handleBack.bind(this)}
          id={this.state.id}

          nhanDuThao={true}
          tuGiaiQuyet={true}
          donInfo={this.state.data}
          thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
          coQuanQuanLyNguoiDung = {this.state.coQuanQuanLyNguoiDung}
          dataNextStates={this.state.dataNextStates}
          listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXM}

          listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM={this.state.data.listTaiLieuVanThuGiaiQuyetDonBaoCaoKQTTXM}
          listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ={this.state.data.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ}
          listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra={this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra}
          listTaiLieuVanThuGiaiQuyetDonGiaHanGQ={this.state.data.listTaiLieuVanThuGiaiQuyetDonGiaHanGQ}

          updateGiaiQuyetDon={this.updateGiaiQuyetDon.bind(this)}
          thongTinGiaiQuyetDonId={this.state.data.thongTinGiaiQuyetDonId}
          saveGiaiQuyetDon={this.saveGiaiQuyetDon.bind(this)}
          loaiDon={this.state.loaiDon}/>
        )
      default:
        return (
        <div className="row pl15 pr15 wrap-block">
          <div className="wrap-big-line pt5 pb20">
            <span className="big-border"></span>
          </div>
          <div className="box-bottom col-100">
            <Link className="btn-action btn-close action-todo" role="button" onClick={this.onClickClose.bind(this)}><span>Đóng</span></Link>
          </div>
        </div>
      )
    }
  }

  checkHideKetQuaXuLyDon() {
    let dataComponents = [
      'CanBoTTXMAction',
      'canBoKiemTraDeXuat',
      'CanBoTDTHAction',
      'CanBoTTXMChuyenDuThaoAction'
    ]
    if (dataComponents.indexOf(this.state.nameComponent) != -1) {
      this.setState({
        hideKetQuaXuLyDon: true
      })
    }
    this.setState({
      formGiaiQuyet : this.renderWorkFollow()
    })
  }

  updateGiaiQuyetDon(params, _params, message) {
    GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({id: this.state.data.thongTinGiaiQuyetDonId},params).then(res => {
      this.postGiaiQuyetDon(_params, message);
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  saveGiaiQuyetDon(params, message) {
    GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({id: this.state.data.thongTinGiaiQuyetDonId},params).then(res => {
      this.onClickClose();
      Toastr(message ? msg[message] : msg.luuGiaiQuyetDonThanhCong, 'success');
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  onClickClose() {
    // browserHistory.goBack();
    if (this.props.fromXLD == true) {
      browserHistory.push('/xu-ly-don');
    } else if (this.props.fromTDTHGQD == true) {
      browserHistory.push('/theo-doi-thuc-hien-giai-quyet-don');
    } else {
      browserHistory.push('/giai-quyet-don');
    }
    this.props.dispatch({
      type: 'REFRESH_MENU',
      value: true
    });
  }

  postGiaiQuyetDon(params, message) {
    GiaiQuyetDonThu.actions.tuGiaiQuyetDon.request('', params).then(res => {
      this.onClickClose();
      Toastr(message ? msg[message] : msg.giaiQuyetDon, 'success');
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  closeConfirmBack() {
    this.state.backConfirm = false;
    this.setState({...this.state});
  }

  handleBack(allowBack) {
    if (allowBack) {
      browserHistory.goBack();
    } else {
      if (this.state.hasChange) {
        this.state.backConfirm = true;
        this.setState({...this.state});
      } else {
        browserHistory.goBack();
      }
    }
  }

  handleChangeData() {
    this.setState({
      hasChange: true
    })
  }

  render() {
    return (
      <div className="center">
        <ConfirmDialog open={this.state.backConfirm} onClose={this.closeConfirmBack.bind(this)} onSuccess={this.handleBack.bind(this, true)}
          title={msg.confirmBack} />
        <div className="back-foward">
          <Link onClick={ this.handleBack.bind(this, false) } title="">Về trang trước</Link>
        </div>
        <div className="heading">
          <h2 className="heading-title icon-detail">Thông tin giải quyết đơn/vụ việc</h2>
        </div>
        <div className="page-wrapper">
          <ChiTietDon isOpen={this.state.isOpen} donId={this.state.id} loaiDon={this.state.loaiDon} dataGiaiQuyet={this.state.dataLichSuGiaiQuyet} data={this.state.data}/>
          <QuaTrinhXuLy parents={this}/>
        </div>
        {
          !this.state.hideKetQuaXuLyDon ?
            <div className="page-wrapper">
              <KetQuaXuLyDon donInfo={this.state.data} status={this.state.hideKetQuaXuLyDon} {...this.state.dataKetQuaXuLyDon} dataGiaiQuyet={this.state.dataLichSuGiaiQuyet}/>
            </div>
          :null
        }
        <div className="page-wrapper mb30">
          {this.state.formGiaiQuyet}
        </div>
      </div>
    );
  }
}

TuGiaiQuyetDon.defaultProps = {
  fromXLD: false,
  fromTDTHGQD: false
}

export default connect()(TuGiaiQuyetDon);



// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/TuGiaiQuyetDon.jsx